/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefineMenuInputRangeDimensions_filters$ref = any;
export type SbSharedRefineMenuInputRangeDimensions_filters = ReadonlyArray<{
    readonly name: string | null;
    readonly localizedFilterName: string | null;
    readonly values: ReadonlyArray<{
        readonly urlLabel: string | null;
        readonly stats: ReadonlyArray<{
            readonly key: string | null;
            readonly values: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": SbSharedRefineMenuInputRangeDimensions_filters$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuInputRangeDimensions_filters",
    "type": "SearchBrowseFilter",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "localizedFilterName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "values",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseFilterValue",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "urlLabel",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "stats",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "stats",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "key",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "values",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'f26658948f8154ac59698898145aef9b';
export default node;
